import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { ZpDataService } from "../services/zp-data.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomValidators } from "../custom-validators";
import { AdminDashboardService } from "src/app/services/admin-dashboard.service";
import { GetInfoAndPassService } from "../services/get-info-and-pass.service";
import { ThemeService } from "../theme/theme-service.service";
import { DelegateHelpers } from "../helpers/delegate-helpers";
import { Router } from "@angular/router";
import plantree from "../../assets/data/plan-tree.json";
import { PreviousUrlService } from "../services/previous-url.service";
import { IUser } from '../models/user.model';
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-professional-home-page",
  templateUrl: "./professional-home-page.component.html",
  styleUrls: ["./professional-home-page.component.scss"],
})

export class ProfessionalHomePageComponent implements OnInit {
  @ViewChild('textarea') textarea: ElementRef<HTMLTextAreaElement>;
  @ViewChild('myModal') myModal: ElementRef;
  public customers;
  public user: IUser = {} as IUser;
  public userBeingEdited;
  public refCode: string;
  public submitted: boolean = false;
  public showTeamMateAddView: boolean = false;
  public showTeamMateUpdateView: boolean = false;
  public currentlyEditingMember: { password: ""; email: ""; name: "", phone: "" };
  public createNewMemberForm: FormGroup;
  public logoUrl: string;
  public clientSignUpLink: string =
    "Your clients can sign up to Zenplans using this unique link.";
  public clientLink: string = "https://app.zenplans.com/";
  public clientIntroEmail: string =
    "Email templates to help you introduce Zenplans to your clients.";
  public changeLogoTooltip: string =
    "Click the button and select a new logo to represent your company.";
  public dataIsLoaded: boolean;
  public currentFile: File;
  public message: string;
  public list = [];
  public section = "professionals_config";
  public item: any;
  public itemIsNotSaved: boolean;
  public statusResources;
  public statusTeamMembers;
  public statusClientIssues;
  public statusSuggestions;
  public statusAttachments: string;
  public textCopied: boolean;
  public activeTheme: any;
  public isDefaultTheme: boolean;
  public clientsFeed: any;
  public userNameLookup = {};
  public userEvent: any;
  public subscription: Promise<void>;
  public mySharedPlans: any;
  public planInClientsFeedSharedPlans = [];
  public hideSponsor: any;
  public newArray: any = [];
  public viewButton: boolean = false;
  public showViewButton = {};
  public previousLink: string;
  public emailSubject: string;
  public emailBody: string;
  public modalTitle: string;
  public nudgeEmailToSend: { mailSubject: string; mailBody: string; mode: string, userList: any };
  public inputEmailSubject: string;
  public selectedUserId: any;
  public filteredCustomers = []; // Array to store filtered customers
  public statusFilter: any;
  public emailTemplate: any;
  emailTemplateNudge: any;
  emailTemplateDelegate: any;
  insertFieldValues: any;
  searchTerm: string = '';
  editableTemplateBody: string;


  constructor(
    private api: ZpDataService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private formBuilder: FormBuilder,
    private adminDashboardService: AdminDashboardService,
    private getInfoAndPassService: GetInfoAndPassService,
    public themeService: ThemeService,
    private delegateHelpers: DelegateHelpers,
    private router: Router,
    private previousUrl: PreviousUrlService,
    private datePipe: DatePipe
  ) {
    this.item = { content: "" };
    if (window["WHITE_LABEL_SITE_URL"]) {
      this.clientLink = window["WHITE_LABEL_SITE_URL"];
    }
    this.userEvent = { "attachment": "Added an attachment", "cancel_account": "Cancelled their account", "item_add": "Added an item", "item_deleted": "Deleted an item", "item_deleted_permanently": "Permanently deleted and item", "item_update": "Updated an item", "login_success": "Logged in", "new_delegate_upsert": "Added a new delegate", "registered_delegate_upsert": "Added a new delegate", "request_for_access": "Requested access to a locked plan", "response_for_access": "Received a response to their request for access to a locked plan", "restored": "Restored an item they had previously deleted", "shared_item_add": "Added a new item to a shared plan as a delegate", "shared_item_update": "Updated an existing item to a shared plan as a delegate", "user_details_update": "Updated their user details", "user_or_delegate_deleted": "Removed a delegate", "user_registration": "Signed up", "user_update": "Updated their user details" }
  }

  updateScreen() {
    this.api.getUser().then(async (user) => {
      this.user = user;
      this.refCode = user.license.refCode;
      if (user && user.attachments) {
        let logo = user.attachments.find((a) => a.fileName == "logo");
        if (logo && user.license && user.license.refCode) {
          this.logoUrl = await this.api.getLogoUrl(user.license.refCode);
        }
      }
      if (user.attachments == undefined) {
        this.statusAttachments = "empty";
        user["statusAttachments"] = this.statusAttachments;
        this.getInfoAndPassService.getInfoAndPass(this.statusAttachments);
      }
    });
  }
  async ngOnInit() {
    this.statusFilter = null;
    this.previousLink = this.previousUrl.getPreviousUrl();
    if (this.previousLink === "/log-in") {
      window.location.reload();
    }
    this.activeTheme = this.themeService.active;
    if (this.activeTheme.name != "defaultTheme") {
      this.isDefaultTheme = false;
    }
    this.customers = [];
    this.api.getCustomers().then((customers) => {
      this.customers = customers;
      console.log('All customers: ', this.customers);
      this.customers.forEach(customer => {
        if (!customer.firstName && !customer.lastName) {
          this.userNameLookup[customer.clientId] = customer.email;
        } else {
          this.userNameLookup[customer.clientId] = customer.firstName + " " + customer.lastName;
        }
      });
      if (this.customers.length > 0) {
        this.filterCustomers();
      }
    });
    this.api.getFeedClients().then((clients) => {
      this.clientsFeed = clients.clientFeed;
      console.log("clientsFeed - ", this.clientsFeed);
    });
    this.updateScreen();
    this.insertFieldValues = await this.api.getProfessionalInviteTemplatePlaceholders();
    this.subscription = this.api.getUser().then(async user => {
      this.hideSponsor = this.api.getRefCodeInfo() && this.api.getRefCodeInfo().hideSponsor;

      // First, we call the getSharedPlans method to get the shared plans
      this.mySharedPlans = await this.api.getSharedPlans(this.user);
      console.log('mySharedPlans - ', this.mySharedPlans)
      let clientsFeedSharedPlans = [];

      for (let sharedPlan = 0; sharedPlan < this.mySharedPlans.length; sharedPlan++) {
        clientsFeedSharedPlans.push(this.mySharedPlans[sharedPlan]);

        if (this.clientsFeed) {

          for (let clientFeed = 0; clientFeed < this.clientsFeed.length; clientFeed++) {
            if (this.clientsFeed[clientFeed].user == clientsFeedSharedPlans[sharedPlan].clientId) {
              this.clientsFeed[clientFeed].sharedPlan = true;
              this.planInClientsFeedSharedPlans.push(this.clientsFeed[clientFeed]);
              for (let itemPlan = 0; itemPlan < plantree.length; itemPlan++) {
                let sectionObjects = plantree[itemPlan].sectionObjects;
                console.log('sectionObjects', sectionObjects)
                if (sectionObjects) {
                  for (let sectionObject = 0; sectionObject < sectionObjects.length; sectionObject++) {
                    if (sectionObjects[sectionObject].section == this.clientsFeed[clientFeed].section) {
                      this.showViewButton[this.clientsFeed[clientFeed]._id] = true
                    }
                  }
                }
              }
            }
          }
        }
      }
    });
    this.createNewMemberForm = this.formBuilder.group({
      name: ["", Validators.required],
      email: ["", [Validators.email, Validators.required]],
      phone: ["", Validators.required],
      password: [
        "",
        Validators.compose([
          Validators.required,
          // check whether the entered password has a number
          CustomValidators.patternValidator(/\d/, {
            hasNumber: true,
          }),
          // check whether the entered password has upper case letter
          CustomValidators.patternValidator(/[A-Z]/, {
            hasCapitalCase: true,
          }),
          // check whether the entered password has a lower case letter
          CustomValidators.patternValidator(/[a-z]/, {
            hasSmallCase: true,
          }),
          Validators.minLength(8),
        ]),
      ],
    });
    this.reloadList();
    this.nudgeEmailToSend = {
      mailBody: '',
      mailSubject: '',
      mode: "nudge",
      userList: [],
    };
    this.loadTemplates();
    setTimeout(() => {
      this.calculateMfaEmailCount();
    }, 1000);
  }

  setStatusFilter(status: string) {
    this.statusFilter = status;
    this.filterCustomers();
  }

  filterCustomers() {
    if (this.statusFilter === null) {
      this.filteredCustomers = this.customers;
    } else if (this.statusFilter === 'invited') {
      this.filteredCustomers = this.customers.filter((customer) =>
        customer.userType === 'invited'
      );
    } else if (this.statusFilter === 'created') {
      this.filteredCustomers = this.customers.filter(
        (customer) =>
          customer.userType === 'planHolder' && customer.isDelegate === false
      );
    } else if (this.statusFilter === 'delegate') {
      this.filteredCustomers = this.customers.filter(
        (customer) =>
          customer.userType === 'planHolder' && customer.isDelegate === true
      );
    }

    if (this.searchTerm && this.searchTerm.trim() !== '') {
      const searchTermLower = this.searchTerm.toLowerCase();
      this.filteredCustomers = this.filteredCustomers.filter((customer) => {
        const fullName = (customer.firstName + ' ' + customer.lastName).toLowerCase();
        return fullName.includes(searchTermLower);
      });
    }
  }


  calculateMfaEmailCount() {
    this.filteredCustomers.forEach((customer) => {
      const emailHistory: any[] = customer.email_history;
      let nudgeEmailCount = 0;
      let lastEmailTime = 0;
      if (emailHistory) {
        emailHistory.forEach((email: any) => {
          if (email.template === '__nudge') {
            nudgeEmailCount++;
            const emailTime = email.date;
            if (emailTime > lastEmailTime) {
              lastEmailTime = emailTime;
            }
          }
        });
      }
      const formattedLastEmailTime = this.datePipe.transform(lastEmailTime, 'short');
      customer.nudgeEmailCount = nudgeEmailCount;
      customer.lastEmailTime = formattedLastEmailTime;
    });
  }
  
  getTooltipText(customer: any): string {
    if (customer.nudgeEmailCount > 0) {
      const formattedLastEmailTime = this.datePipe.transform(customer.lastEmailTime, 'dd.MM.yyyy');
      return `Last Nudge Sent: ${formattedLastEmailTime} Total Nudges Sent: ${customer.nudgeEmailCount}`;
    } else {
      return "No nudges have been sent.";
    }
   
  }

  async reloadList() {
    this.list = await this.api.getProfessionalResource();
    if (this.list.length) {
      this.item = this.list[0];
    }
  }

  get f() {
    return this.createNewMemberForm.controls;
  }

  async onSubmit() {
    this.submitted = true;
    if (this.createNewMemberForm.invalid) {
      return;
    }
    this.api
      .addOrUpdateTeamMember(this.createNewMemberForm.value)
      .then((response) => {
        this.showTeamMateAddView = false;
        this.updateScreen();
      });
  }

  editTeamMember(teamMember: any) {
    teamMember.password = null;
    this.showTeamMateUpdateView = true;
    this.currentlyEditingMember = teamMember;
  }

  updateTeamMember() {
    if (
      !this.currentlyEditingMember.password ||
      this.currentlyEditingMember.password == ""
    ) {
      // || this.currentlyEditingMember.password.length >= 4
      delete this.currentlyEditingMember.password;
    }
    this.api
      .addOrUpdateTeamMember(this.currentlyEditingMember)
      .then((response) => {
        this.showTeamMateUpdateView = false;
        this.currentlyEditingMember = undefined;
        this.updateScreen();
      });
  }

  removeTeamMember(email) {
    var member = this.user.team.find((m) => m.email == email);
    this.api.deleteTeamMember(member).then((response) => {
      this.updateScreen();
    });
  }

  async fileUpload(element) {
    this.dataIsLoaded = false;
    this.currentFile = await this.api.uploadFile(
      element.target.files[0],
      this.user.clientId,
      "logo"
    );
    let result = await this.api.uploadFile(
      element.target.files[0],
      this.user.clientId,
      "logo"
    );
    if (result.success) {
      this.dataIsLoaded = true;
      window.location.reload();
    } else {
      this.message = "Sorry, your file could not be uploaded.";
    }
  }

  copyText(val: string) {
    let selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
    this.textCopied = true;
    setTimeout(() => {
      this.textCopied = false;
    }, 3000);
  }

  seeSharedPlan($event, index, section, chosenPlan, professional) {
    let treeSection = section;
    let treeCategory;
    for (let itemPlan = 0; itemPlan < plantree.length; itemPlan++) {
      let sections = plantree[itemPlan].sectionObjects;
      if (sections) {
        for (let section = 0; section < sections.length; section++) {
          if (sections[section].section === treeSection) {
            console.log('section - ', treeSection)
            console.log('sections[section] - ', sections[section])
            console.log('plantree[itemPlan] - ', plantree[itemPlan].planCategory)
            treeCategory = plantree[itemPlan].planCategory;
          }
        }
      }
    }
    switch (treeCategory) {
      case 'my assets':
        this.checkSharedPlanRightAccess('assets', '/my-assets/', chosenPlan, index, professional)
        break;
      case 'my debts':
        this.checkSharedPlanRightAccess('debts', '/my-debts/', chosenPlan, index, professional)
        break;
      case 'my daily life':
        this.checkSharedPlanRightAccess('dailyLife', '/my-daily-life/', chosenPlan, index, professional)
        break;
      case 'my wishes':
        this.checkSharedPlanRightAccess('wishes', '/my-wishes/', chosenPlan, index, professional)
        break;
      case 'my digital life':
        this.checkSharedPlanRightAccess('digitalLife', '/my-digital-life/', chosenPlan, index, professional)
        break;
      default:
        console.log('test ');
    }
  }

  checkSharedPlanRightAccess(chosenSection, navigateSection, chosenPlan, index, professional) {
    for (let sharedPlan = 0; sharedPlan < this.mySharedPlans.length; sharedPlan++) {
      if (this.mySharedPlans[sharedPlan].clientId === chosenPlan) {
        switch (chosenSection) {
          case 'assets':
            if (this.mySharedPlans[sharedPlan].assetsPermission != 'never' && this.mySharedPlans[sharedPlan].assetsPermission != 'future') {
              this.delegateHelpers.seeSharedPlan(chosenSection, this.mySharedPlans[sharedPlan], this.user, professional);
              this.router.navigate([navigateSection + chosenPlan['clientId']]);
            } else {
              this.disableAccessButton(index)
            }
            break;
          case 'debts':
            if (this.mySharedPlans[sharedPlan].debtsPermission != 'never' && this.mySharedPlans[sharedPlan].debtsPermission != 'future') {
              this.delegateHelpers.seeSharedPlan(chosenSection, this.mySharedPlans[sharedPlan], this.user, professional);
              this.router.navigate([navigateSection + chosenPlan['clientId']]);
            } else {
              this.disableAccessButton(index)
            }
            break;
          case 'dailyLife':
            if (this.mySharedPlans[sharedPlan].dailyLifePermission != 'never' && this.mySharedPlans[sharedPlan].dailyLifePermission != 'future') {
              this.delegateHelpers.seeSharedPlan(chosenSection, this.mySharedPlans[sharedPlan], this.user, professional);
              this.router.navigate([navigateSection + chosenPlan['clientId']]);
            } else {
              this.disableAccessButton(index)
            }
            break;
          case 'wishes':
            if (this.mySharedPlans[sharedPlan].wishesPermission != 'never' && this.mySharedPlans[sharedPlan].wishesPermission != 'future') {
              this.delegateHelpers.seeSharedPlan(chosenSection, this.mySharedPlans[sharedPlan], this.user, professional);
              this.router.navigate([navigateSection + chosenPlan['clientId']]);
            } else {
              this.disableAccessButton(index)
            }
            break;
        }
      }
      else {
        console.log('Not delegate.')
      }
    }
  }

  visibleIndex = -1;
  disableAccessButton(ind) {
    if (this.visibleIndex === ind) {
      this.visibleIndex = -1;
    } else {
      this.visibleIndex = ind;
    }
  }

  inviteClients() {
    console.log('customers', this.customers)
    if (this.customers && this.customers.length == 0) {
      this.router.navigate(["/upload-professionals-list"]);
    } else {
      this.router.navigate(["/add-clients"]);
    }
  }

  insertText(selectedValue: string) {
    const disabledValues = ['Professional Referral Code', 'Professional Referral Link'];

    const textToInsert = `${selectedValue}`;
    const cursorPosition = this.textarea.nativeElement.selectionStart;
    const textBeforeCursor = this.textarea.nativeElement.value.substring(0, cursorPosition);
    const textAfterCursor = this.textarea.nativeElement.value.substring(cursorPosition);
    const newValue = textBeforeCursor + textToInsert + textAfterCursor;

    this.textarea.nativeElement.value = newValue;

    if (disabledValues.includes(selectedValue)) {
      setTimeout(() => {
        this.disableInsertedValue(selectedValue);
      }, 0);
    }
  }

  disableInsertedValue(selectedValue: string) {
    const textareaValue = this.textarea.nativeElement.value;
    const disabledStartTag = `<disabled>[`;
    const disabledEndTag = `]</disabled>`;

    const startIndex = textareaValue.indexOf(`[${selectedValue}]`);
    if (startIndex !== -1) {
      const endIndex = startIndex + selectedValue.length + 2;
      const disabledValue = disabledStartTag + selectedValue + disabledEndTag;
      this.textarea.nativeElement.value =
        textareaValue.substring(0, startIndex) +
        disabledValue +
        textareaValue.substring(endIndex);
    }
  }

  statusModal(status: string, customerId: number) {
    this.selectedUserId = customerId;
    if (status == 'invited') {
      this.modalTitle = 'Remind client to create a plan';
      this.loadTemplates(status);
    } else if (status == 'created') {
      this.modalTitle = 'Remind client to add you as a delegate';
      this.loadTemplates(status);
    } 
    // else {
    //   this.modalTitle = 'Title for delegate clients';
    //   this.loadTemplates(status);
    // }
  }

  async loadTemplates(status: string = 'default') {
    if (status == 'invited') {
      const template = await this.api.getProfessionalInviteTemplateForModal('nudge');
      console.log('template: ', template);
      this.emailSubject = template.mail_template.subject;
      this.emailBody = template.mail_template.body;
      console.log('emailBody before being extracted: ', this.emailBody);
      this.editableTemplateBody = this.extractContentFromBody(template.mail_template.body);
      console.log
    }
    if (status == 'created') {
      const template = await this.api.getProfessionalInviteTemplateForModal('request_delegate');
      console.log('template: ', template);
      this.emailSubject = template.mail_template.subject;
      this.emailBody = template.mail_template.body;
      console.log('emailBody before being extracted: ', this.emailBody);
      this.editableTemplateBody = this.extractContentFromBody(template.mail_template.body);

    }
  }

  extractContentFromBody(htmlString) {
    let bodyContentRegex = /<div id="body">([\s\S]*?)<\/div>/;
    let match = bodyContentRegex.exec(htmlString);
    if (match) {
      let divContent = match[1];
      return divContent.replace(/<br>/gi, '\n');
    }
  }

  insertContentIntoBody(str: string, htmlString: string) {
    let html = str.replace(/\n/gi, '<br>');
    let updatedHtmlString = htmlString.replace(/(<div id="body">)([\s\S]*?)(<\/div>)/, `$1${html}$3`);
    console.log('updatedHtmlString: ', updatedHtmlString);
    return updatedHtmlString;
  }
  

  inputChangeEmail(event: any, element: string) {
    if (element === 'input') {
      this.inputEmailSubject = event.target.value;
      this.nudgeEmailToSend.mailSubject = this.inputEmailSubject;
    }
  }

  handleChangeSubject(value: string) {
    this.nudgeEmailToSend.mailSubject = value;
  }

  async sendNudge(customerId: number) {
    const textareaValue = this.textarea.nativeElement.value;
    // this.nudgeEmailToSend.mailBody = textareaValue;
    console.log('emailBody before being inserted back: ', this.emailBody);
    this.nudgeEmailToSend.mailBody = this.insertContentIntoBody(textareaValue, this.emailBody);
    console.log('emailBody after being inserted back: ', this.emailBody);
    if (this.inputEmailSubject && this.inputEmailSubject.trim() !== '') {
      this.nudgeEmailToSend.mailSubject = this.inputEmailSubject;
    } else {
      this.nudgeEmailToSend.mailSubject = this.emailSubject;
    }
    this.nudgeEmailToSend.userList = [{ Id: customerId }];
    console.log(this.nudgeEmailToSend);
    try {
      const response = await this.api.sendInvites(this.nudgeEmailToSend);
      alert('Your nudge has been sent successfully.');
      console.log(response);
      this.inputEmailSubject = '';
      this.nudgeEmailToSend.mailSubject = this.emailSubject;
      this.nudgeEmailToSend.mailBody = textareaValue;
    } catch (error) {
      alert('There was a problem sending your nudge. Please try again later.');
      console.error(error);
    }
  }

}
